// extracted by mini-css-extract-plugin
export default {"SidebarItem":"Sidebar_SidebarItem__kp-Sr"};